import React, { useEffect, useRef } from 'react';
import './CumulativeTopicsPopover.css';

const TOPIC_CATEGORIES = [
  ['motivations', 'report_motivations_title'],
  ['barriers', 'report_barriers_title'],
  ['next_steps', 'report_next_steps_title'],
];

function CumulativeTopicsPopover({
  t,
  clientDescription,
  revealedItems,
  open,
  unreadCount,
  onToggle,
  placement,
  style,
}) {
  const rootRef = useRef(null);
  const topicCount = TOPIC_CATEGORIES.reduce(
    (total, [key]) => total + (revealedItems?.[key]?.length || 0),
    0,
  );

  useEffect(() => {
    if (!open) return undefined;

    const handlePointerDown = (event) => {
      if (!rootRef.current?.contains(event.target)) onToggle(false);
    };
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onToggle(false);
    };
    document.addEventListener('pointerdown', handlePointerDown);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('pointerdown', handlePointerDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onToggle, open]);

  return (
    <div
      ref={rootRef}
      className={`cumulative-topics cumulative-topics--${placement}${open ? ' cumulative-topics--open' : ''}`}
      style={style}
    >
      <button
        type="button"
        className="cumulative-topics__trigger"
        onClick={() => onToggle(!open)}
        aria-label={t('report_cumulative_topics_title')}
        aria-expanded={open}
        title={t('report_cumulative_topics_title')}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="5" y="4" width="14" height="16" rx="2" />
          <path d="M9 2.8v3" />
          <path d="M15 2.8v3" />
          <path d="M8.5 10h7" />
          <path d="M8.5 14h7" />
          <path d="M8.5 18h4.5" />
        </svg>
        {unreadCount > 0 && (
          <span className="cumulative-topics__badge" aria-label={`${unreadCount} new topics`}>
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </button>

      {open && (
        <section className="cumulative-topics__panel" aria-label={t('report_cumulative_topics_title')}>
          {clientDescription && (
            <div className="cumulative-topics__client-description">
              <h4>Client Description</h4>
              <p>{clientDescription}</p>
            </div>
          )}
          <div className="cumulative-topics__heading">
            <h4>{t('report_cumulative_topics_title')}</h4>
            <span>{topicCount}</span>
          </div>
          {topicCount > 0 ? TOPIC_CATEGORIES.map(([key, titleKey]) => (
            revealedItems?.[key]?.length > 0 && (
              <div className="cumulative-topics__category" key={key}>
                <h5>{t(titleKey)}</h5>
                <ul>
                  {revealedItems[key].map((item) => <li key={`${key}:${item}`}>{item}</li>)}
                </ul>
              </div>
            )
          )) : (
            <p className="cumulative-topics__empty">Continue the conversation to learn more.</p>
          )}
        </section>
      )}
    </div>
  );
}

export default CumulativeTopicsPopover;
